import axios, { AxiosResponse } from "axios";
import { WebAPI, IFailCallbackParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIから設定ファイルの内容の取得が成功した場合に呼び出されます
   * @callback success
   * @param { IGetConfFileResponceModel } row - 設定ファイル情報
   */
  success: (
    row: IGetConfFileResponceModel,
    status: number
  ) => void;
}

export interface IGetConfFileResponceModel {
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * 設定ファイル名
   */
  name: string;
}

function AxiosGet(url: string, token?: string) {
  if (token) {
    return axios.get(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  } else {
    return axios.get(url);
  }
}

interface IAxiosInternalParams extends ICallbackParams {
  promise: Promise<AxiosResponse>;
}

function AxiosInternal(params: IAxiosInternalParams) {
  params.promise
  .then((res) => {
    params.success(
      res.data,
      res.status
    );
  })
  .catch((err) => {
    const { id, status } = getErrorStatus(err);
    params.fail(id, status);
  });
}

export interface IGetConfFileParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * 設定ファイルの種類
   */
  type: string;
}

/**
 * 指定した種類の設定ファイルを取得します
 * @function getConfFile
 * @param {IGetConfFileParams} params - 設定ファイル取得パラメータ
 */
export function getConfFile(params: IGetConfFileParams): void {
  const { authService, projectid, type } = params;
  const url = WebAPI.GET_CONFFILE(projectid, type);
  if (authService) {
    authService.getToken({
      success: (token) => {
        AxiosInternal({
          promise: AxiosGet(url, token),
          success: params.success,
          fail: (id, status) => {
            if (status === 401) {
              getConfFileRetry401(authService, url, params);
            } else {
              params.fail(id, status);
            }
          },
        });
      },
      fail: (err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      },
    });
  } else {
    AxiosInternal({
      promise: AxiosGet(url),
      success: params.success,
      fail: params.fail,
    });
  }
}

/**
 * 指定した種類の設定ファイルを取得します
 * @function getConfFileRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {ICallbackParams} params - コールバックパラメータ
 */
export function getConfFileRetry401(
  authService: AuthService,
  url: string,
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      AxiosInternal({
        promise: AxiosGet(url, token),
        success: params.success,
        fail: params.fail,
      });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}